import React from 'react';
import { Loader2 } from 'lucide-react';

// Standardized loading spinner component
export const LoadingSpinner = ({ size = 'default', text = 'Loading...', fullScreen = false }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    default: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    default: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Loader2 className={`${sizeClasses[size]} text-primary animate-spin mx-auto mb-4`} />
          <p className={`text-muted-foreground ${textSizeClasses[size]}`}>{text}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      <div className="text-center">
        <Loader2 className={`${sizeClasses[size]} text-primary animate-spin mx-auto mb-3`} />
        <p className={`text-muted-foreground ${textSizeClasses[size]}`}>{text}</p>
      </div>
    </div>
  );
};

// Inline loading button spinner
export const ButtonSpinner = ({ size = 16, className = '' }) => (
  <Loader2 size={size} className={`animate-spin ${className}`} />
);

// Small inline spinner for cards
export const InlineSpinner = ({ text, className = '' }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <Loader2 size={16} className="text-primary animate-spin" />
    <span className="text-sm text-muted-foreground">{text}</span>
  </div>
);

export default LoadingSpinner;
